/**
 * Listen to event and forward to another entity or entities.
 */
AFRAME.registerComponent('delayed-proxy-event', {
  schema: {
    captureBubbles: {default: false},
    enabled: {default: true},
    event: {type: 'string'},
    from: {type: 'string'},
    to: {type: 'string'},
    as: {type: 'string'},
    bubbles: {default: false},
    delay: {default: 0, type: 'int'}
  },

  multiple: true,

  init: function () {
    var data = this.data;
    var el = this.el;
    var from;
    var i;
    var to;
    var self = this;

    if (data.from) {
      if (data.from === 'PARENT') {
        from = [el.parentNode];
      } else {
        from = document.querySelectorAll(data.from);
      }
    } else {
      if (data.to === 'CHILDREN') {
        to = el.querySelectorAll('*');
      } else if (data.to === 'SELF') {
        to = [el];
      } else {
        to = document.querySelectorAll(data.to);
      }
    }

    if (data.from) {
      for (i = 0; i < from.length; i++) {
        this.addEventListenerFrom(from[i]);
      }
    } else {
      el.addEventListener(data.event, function (evt) {
        setTimeout(() => {
          var data = self.data;
          if (!data.enabled) { return; }
          if (!data.captureBubbles && evt.target !== el) { return; }
          for (i = 0; i < to.length; i++) {
            to[i].emit(data.as || data.event, evt['detail'] ? evt.detail : null, data.bubbles);
          }
        }, data.delay);
      });
    }
  },

  addEventListenerFrom: function (fromEl) {
    var data = this.data;
    var self = this;
    fromEl.addEventListener(data.event, function (evt) {
      setTimeout(() => {
        var data = self.data;
        if (!data.enabled) { return; }
        if (!data.captureBubbles && evt.target !== fromEl) { return; }
        self.el.emit(data.as || data.event, evt['detail'] ? evt.detail : null, false);
      }, data.delay);
    });
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['delayed-proxy-event',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
